import { AxiosInstance } from 'axios';
import createNotification from '../../utils/createNotification';

export class FileSelectorService {
    constructor(private axios: AxiosInstance) {}

    public uploadFile = async (file: File): Promise<number> => {
        const formData = new FormData();
        formData.append('File', file);
        const responses = await this.axios.post(
            `/api/temporaryfiles`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        if (responses.status !== 200) {
            createNotification(
                'Some files are not uploaded due to an unexpected error.',
                'error'
            );
            throw new Error(
                'Some files are not uploaded due to an unexpected error.'
            );
        } else {
            return responses.data.id;
        }
    };
}
